var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54.7925,
    height: 54.7925,
    rx: 16,
    fill: "#4928FD",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_12150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 15,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15.3965,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_12150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 37.3965C20.45 37.3965 19.9792 37.2007 19.5875 36.809C19.1958 36.4173 19 35.9465 19 35.3965V25.3965C19 24.8465 19.1958 24.3757 19.5875 23.984C19.9792 23.5923 20.45 23.3965 21 23.3965H22V21.3965C22 20.0132 22.4875 18.834 23.4625 17.859C24.4375 16.884 25.6167 16.3965 27 16.3965C28.3833 16.3965 29.5625 16.884 30.5375 17.859C31.5125 18.834 32 20.0132 32 21.3965V23.3965H33C33.55 23.3965 34.0208 23.5923 34.4125 23.984C34.8042 24.3757 35 24.8465 35 25.3965V35.3965C35 35.9465 34.8042 36.4173 34.4125 36.809C34.0208 37.2007 33.55 37.3965 33 37.3965H21ZM21 35.3965H33V25.3965H21V35.3965ZM27 32.3965C27.55 32.3965 28.0208 32.2007 28.4125 31.809C28.8042 31.4173 29 30.9465 29 30.3965C29 29.8465 28.8042 29.3757 28.4125 28.984C28.0208 28.5923 27.55 28.3965 27 28.3965C26.45 28.3965 25.9792 28.5923 25.5875 28.984C25.1958 29.3757 25 29.8465 25 30.3965C25 30.9465 25.1958 31.4173 25.5875 31.809C25.9792 32.2007 26.45 32.3965 27 32.3965ZM24 23.3965H30V21.3965C30 20.5632 29.7083 19.8548 29.125 19.2715C28.5417 18.6882 27.8333 18.3965 27 18.3965C26.1667 18.3965 25.4583 18.6882 24.875 19.2715C24.2917 19.8548 24 20.5632 24 21.3965V23.3965Z",
    fill: "#4928FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.0801919c13886517aa46da0cd6f1c238.svg";
export { ForwardRef as ReactComponent };